module.exports = __webpack_public_path__ + "../resources/img/ic_re_symbol_arc.733fdb65.svg";